"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMemoryGamePrompt = getMemoryGamePrompt;
const taskStore_1 = require("../../../taskStore");
function getMemoryGamePrompt(mode, reverse) {
    const inputAudioPrompt = reverse
        ? (0, taskStore_1.taskStore)().heavyInstructions
            ? 'memoryGameInstruct11Downex'
            : 'memoryGameBackwardPrompt'
        : (0, taskStore_1.taskStore)().heavyInstructions
            ? 'memoryGameInstruct8Downex'
            : 'memoryGameInput';
    const displayAudioPrompt = (0, taskStore_1.taskStore)().heavyInstructions ? 'memoryGameInstruct7Downex' : 'memoryGameDisplay';
    const prompt = mode === 'display' ? displayAudioPrompt : inputAudioPrompt;
    return prompt;
}
